<template>
  <div @mouseover="mouseoverSidemenu()" @mouseleave="mouseleaveSidemenu()">
    <div class="side-menu admin">
      <router-link to="/">
        <div class="logo-wrap">
          <img :src="dark_logo" class="logo" />
          <p class="logofont dark">DB ADMIN</p>
        </div>
      </router-link>
      <div class="side-menu-menu" id="sidemenu">
        <el-menu unique-opened @open="changeOpeneds" @close="closeOpeneds" :default-openeds="openMenu">
          <div class="divider dark"></div>
          <el-menu-item index="0" class="admin" :class="[parent == 'Dashboard' ? 'isActive admin' : '']" @click="changeActive('Dashboard')">
            <div class="title-icon dark">
              <i class="el-icon-suitcase"></i>
            </div>
            ダッシュボード
          </el-menu-item>
          <el-menu-item index="1" class="admin" :class="[parent == 'Client' ? 'isActive admin' : '']" @click="changeActive('Client')">
            <div class="title-icon dark">
              <i class="el-icon-office-building"></i>
            </div>
            クライアント情報
          </el-menu-item>
          <el-menu-item index="2" class="admin" :class="[parent == 'Influencer' ? 'isActive admin' : '']" @click="changeActive('Influencer')">
            <div class="title-icon dark">
              <i class="el-icon-user"></i>
            </div>
            インフルエンサー情報
          </el-menu-item>
          <el-menu-item index="3" class="admin" :class="[parent == 'Admin' ? 'isActive admin' : '']" @click="changeActive('Admin')">
            <div class="title-icon dark">
              <i class="el-icon-setting"></i>
            </div>
            管理
          </el-menu-item>
        </el-menu>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "adminSidemenu",
  props: ["parent"],
  components: {},
  data() {
    return {
      dark_logo: require("../../../src/assets/reechlogo_white.png"),
      logo: require("../../../src/assets/reechlogo.png"),
    };
  },
  computed: {},
  mounted() {},
  methods: {
    changeActive(value) {
      this.parent = value;
      this.$emit("update:parent", value);
    },
    mouseoverSidemenu() {
      document.documentElement.style.overflow = "hidden";
    },
    mouseleaveSidemenu() {
      document.documentElement.style.overflow = "auto";
    },
  },
  watch: {},
};
</script>
